import type { OutputEmitterRef } from '@angular/core';
import { InjectionToken } from '@angular/core';

import type { ISelectController, SelectResolvedTemplate } from '../../types';

export interface MultiselectFeature {
  chipRemoved: OutputEmitterRef<void>;
  selectController: ISelectController;
  selectedItemCounterDirective: SelectResolvedTemplate;
}

export const MULTISELECT_FEATURE = new InjectionToken<MultiselectFeature>('multiselect feature');
